export type Modify<T, X> = Omit<T, keyof X> & X;

export function assertNever(value: never): never {
  throw new Error(`Unexpected subscription status: ${value}`);
}
